import { computed, defineComponent, nextTick, reactive, watch, h } from '@vue/composition-api';
import { withInstall } from '../util/index';
import useImgFallback from '../util/useImgFallback';
import "../style/components/avatar.css";
var Avatar = defineComponent({
  name: 'm-avatar',
  props: {
    src: {
      type: String,
      "default": ''
    },
    errorSrc: {
      type: String,
      "default": ''
    },
    alt: {
      type: String,
      "default": ''
    },
    borderRadius: {
      type: [String, Number],
      "default": ''
    },
    gap: {
      type: [String, Number],
      "default": '4'
    }
  },
  slots: ['default'],
  setup: function setup(props, context) {
    var getFallBackInfo = function getFallBackInfo() {
      return useImgFallback({
        src: props.src,
        alt: props.alt,
        errorSrc: props.errorSrc
      });
    };

    var imgInfo = getFallBackInfo();
    var widthInfo = reactive({
      boxWidth: 0,
      altWidth: 0
    });

    var reComputeWidthInfo = function reComputeWidthInfo() {
      var _context$refs$alt;

      widthInfo.altWidth = ((_context$refs$alt = context.refs.alt) === null || _context$refs$alt === void 0 ? void 0 : _context$refs$alt.clientWidth) || 0;

      if (!widthInfo.boxWidth) {
        var _context$refs$box;

        widthInfo.boxWidth = ((_context$refs$box = context.refs.box) === null || _context$refs$box === void 0 ? void 0 : _context$refs$box.clientWidth) || 0;
      }
    };

    var altStyle = computed(function () {
      if (!widthInfo.boxWidth || !widthInfo.altWidth) return;
      var innerWidth = widthInfo.boxWidth - +props.gap * 2;
      if (innerWidth >= widthInfo.altWidth) return;
      return {
        transform: "scale(".concat(innerWidth / widthInfo.altWidth, ") translateX(-50%)")
      };
    });
    watch(function () {
      return imgInfo.alt;
    }, function (newValue) {
      if (!newValue) return;
      nextTick(reComputeWidthInfo);
    }, {
      immediate: true
    });
    watch([function () {
      return props.src;
    }, function () {
      return props.errorSrc;
    }, function () {
      return props.alt;
    }], function () {
      imgInfo = getFallBackInfo();
    });
    return function () {
      return h("div", {
        "class": 'm-avatar',
        "ref": 'box',
        "style": {
          borderRadius: isNaN(+props.borderRadius) ? props.borderRadius : "".concat(props.borderRadius, "px")
        }
      }, [imgInfo.src && h("img", {
        "class": 'm-avatar_img',
        "attrs": {
          "src": imgInfo.src
        }
      }), imgInfo.alt && h("div", {
        "class": 'm-avatar_alt',
        "ref": 'alt',
        "style": altStyle.value
      }, [imgInfo.alt])]);
    };
  }
});
withInstall(Avatar);
export default Avatar;